import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

interface Props {
  isLoading: boolean;
  value: number;
}

const useStyles = makeStyles({
  root: {
    height: 32,
  },
});

const Change: FC<Props> = ({ isLoading, value }) => {
  const classes = useStyles();

  if (isLoading) {
    return null;
  }

  if (value === 0) {
    return (
      <Typography variant="subtitle1" color="textSecondary" className={classes.root}>
        {'--'}%
      </Typography>
    );
  }

  if (value > 0) {
    return (
      <Typography variant="subtitle1" color="secondary" className={classes.root}>
        {value}%
      </Typography>
    );
  }

  return (
    <Typography variant="subtitle1" color="error" className={classes.root}>
      {Math.abs(value)}%
    </Typography>
  );
};

export default Change;
